import { render, staticRenderFns } from "./ImportedPaymentSuggestions.vue?vue&type=template&id=cc96bf02&scoped=true"
import script from "./ImportedPaymentSuggestions.vue?vue&type=script&lang=ts"
export * from "./ImportedPaymentSuggestions.vue?vue&type=script&lang=ts"
import style0 from "./ImportedPaymentSuggestions.vue?vue&type=style&index=0&id=cc96bf02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc96bf02",
  null
  
)

export default component.exports